<template>
  <Card>
    <div class="cardTitle">{{ $t('Стадии процедуры') }}</div>
    <slot>
    </slot>
    <v-divider class="intec-blue--border border-opacity-50" />
    <div class="cardTitle">{{ $t('Организатор') }}</div>
    <div class="organization">
      {{ organization }}
    </div>
  </Card>
</template>

<script>
import Card from "@intec/vue-components/form/Card.vue";

export default {
  name: 'StagesInfo',
  components: { Card },
  props: {
    organization: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.organization {
  padding-left: 10px;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: rgba(var(--black-color), 0.8);
}
</style>